import { useEffect, useState } from "react";
import CookiesJs from "js-cookie";


export default function CookieBanner() {
    const [visible, setVisible] = useState(false);
    const [settingsOpen, setSettingsOpen] = useState(false);

    const [consent, setConsent] = useState({
        technical: true,
        analytics: false,
        marketing: false,
    });
    
    useEffect(() => {
        const saved = CookiesJs.get("cookie_consent");
        if (!saved) setVisible(true);
    }, []);

    const save = (data) => {
        CookiesJs.set("cookie_consent", JSON.stringify(data), {
            expires: 365,
        });

        setVisible(false);
    };

    const acceptAll = () => {
        const all = {
            technical: true,
            analytics: true,
            marketing: true,
        };

        setConsent(all);
        save(all);
    };

    const declineAll = () => {
        const minimal = {
            technical: true,
            analytics: false,
            marketing: false,
        };

        setConsent(minimal);
        save(minimal);
    };

    if (!visible) return null;

    return (
        <div className="overlayCookie">

            {!settingsOpen ? (
                <>
                    <div className="modalCookie">
                        <div className="textCookie">
                            Для сбора статистики, удобства пользователей, корректной работы сайта и предоставления персонализированных рекомендаций мы используем файлы cookie.
                            {" "}
                            <button
                                className="linkCookie"
                                onClick={() => setSettingsOpen(true)}
                            >
                                Настроить cookie
                            </button>
                            <p style={{ margin: "10px 0 0 0" }}>
                                Нажав «Принять», вы соглашаетесь на их обработку в соответствии с <a className="linkCookie" href="https://atlcredit.by/Politika-obrabotki-fajlov-cookie.pdf">Политикой</a> обработки файлов cookie.
                            </p>
                        </div>

                        <div className="rowCookie">
                            <button className="primaryCookie cookieBtn" onClick={acceptAll}>
                                Принять
                            </button>

                            <button className="secondaryCookie cookieBtn" onClick={declineAll}>
                                Отклонить
                            </button>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="modalCookie settingsCookies">
                        <div className="settingsCookie">
                            <div className="w30">
                                Для сбора статистики, удобства пользователей, корректной работы сайта и предоставления персонализированных рекомендаций мы используем файлы cookie.
                                <p style={{ margin: "10px 0 0 0" }}>
                                    Нажав «Принять», вы соглашаетесь на их обработку в соответствии с <a className="linkCookie" href="https://atlcredit.by/Politika-obrabotki-fajlov-cookie.pdf">Политикой</a> обработки файлов cookie.
                                </p>
                            </div>

                            <div className="w45">
                                <div className="itemCookie" >
                                    <div className="itemCookieTitle">
                                        <span className="cookieTitle">Технические (обязательные)</span>
                                        <span style={{ color: "green" }}>Always active</span>
                                    </div>
                                    <p className="itemCookieText">
                                        Требуются для обеспечения функционирования Сайта, в том числе корректного использования предлагаемых на нем возможностей и услуг, и не подлежит отключению.
                                    </p>
                                </div>

                                <div className="itemCookie" >
                                    <div className="itemCookieTitle">
                                        <span className="cookieTitle">Аналитические</span>
                                        <input
                                            type="checkbox"
                                            checked={consent.analytics}
                                            onChange={(e) =>
                                                setConsent((prev) => ({
                                                    ...prev,
                                                    analytics: e.target.checked,
                                                }))
                                            }
                                        />
                                    </div>
                                    <p className="itemCookieText">Позволяют хранить историю посещений страниц сайта в целях повышения качества его функционирования, чтобы определить, например, наиболее и наименее популярные страницы (разделы), а также иную информацию.</p>
                                </div>

                                <div className="itemCookie" >
                                    <div className="itemCookieTitle">
                                        <span>Маркетинговые</span>
                                        <input
                                            type="checkbox"
                                            checked={consent.marketing}
                                            onChange={(e) =>
                                                setConsent((prev) => ({
                                                    ...prev,
                                                    marketing: e.target.checked,
                                                }))
                                            }
                                        />
                                    </div>
                                    <p className="itemCookieText">Используются для целей маркетинга и улучшения качества рекламы, предоставления пользователю более актуального и подходящего контента, персонализированного рекламного материала, основанного на интересах пользователя.</p>
                                </div>
                            </div>
                        </div>

                        <div className="rowBlockCookie">
                            <button className="primaryCookie cookieBtn"
                                className="primaryCookie cookieBtn"
                                onClick={acceptAll}
                            >
                                Принять все
                            </button>

                            <button
                                className="secondaryCookie cookieBtn"
                                onClick={declineAll}
                            >
                                Отклонить
                            </button>

                            <button
                                className="secondaryCookie cookieBtn"
                                onClick={() => save(consent)}
                            >
                                Сохранить
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
